module.exports = __webpack_public_path__ + "img/03@2x.3b70fee8.png";